module.exports = __webpack_public_path__ + "static/media/remove_icon.470da858.svg";